const initialProduct = []

export default initialProduct;